import { END_POINTS } from "../helpers";
import emptySplitApi from "../utils/rtk";

type CommonResponseType = {
  data: ResponseData;
  status: number;
  message: string;
};
type ResponseData = {
  response_object: any;
  total_records: number;
  start: number;
  length: number;
};

type Body = {
  //   start: number;
  //   length: number;
  //   search: string;
  order_status: any;
};

type UpdateQuoteParams = {
  body: {
    price_per_unit: number;
    offer_valid_time: number;
    delivery_condItions: number;
    payment_method: number;
    product: number;
  };
  id: string | undefined;
};

export const quoteApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllQuote: builder.mutation<CommonResponseType & { data: any }, Body>({
      query: (body) => ({
        url: END_POINTS.getAllQuotes,
        method: "POST",
        body,
      }),
    }),

    revertQuote: builder.mutation<CommonResponseType, UpdateQuoteParams>({
      query: ({ body, id }) => ({
        url: `${END_POINTS.revertQuote}${id}/`,
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const { useGetAllQuoteMutation, useRevertQuoteMutation } = quoteApi;
